import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import styled from 'styled-components';

import { FileManagerDragLayer } from '../../components/file-manager/folder-list-view/file-manager-drag-layer';
import { LeftArea } from '../../components/file-manager/left-area';
import { RightArea } from '../../components/file-manager/right-area';
import { FolderListViewState } from '../../components/file-manager/state/folder-list-view-state';
import { FolderTreeState } from '../../components/file-manager/state/folder-tree-state';

const FileManagerPage = () => {
  return (
    <FileManagerContainer>
      <FolderTreeState>
        <FileManagerComponent>
          <DndProvider
            backend={HTML5Backend}
            /* Explicit window so the backend uses the same document as the app (required for drop targets to highlight in Vite/ESM). */
            context={typeof window !== 'undefined' ? window : undefined}
          >
            <FileManagerDragLayer />
            <LeftArea />
            <FolderListViewState filesCheckable={true} foldersCheckable={true}>
              <RightArea />
            </FolderListViewState>
          </DndProvider>
        </FileManagerComponent>
      </FolderTreeState>
    </FileManagerContainer>
  );
};

const FileManagerComponent = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  background-color: #fff;

  // Left area.
  ${LeftArea.styled} {
    width: 300px;
    min-width: 300px;
  }

  // Content area.
  ${RightArea.styled} {
    flex: 1;
  }
`;

const FileManagerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 0;

  > * {
    height: 100%;
  }
`;

export { FileManagerPage };
